const hidden = (name = "hero", value = null) => ({
  name,
  widget: "hidden",
  value,
});

export default hidden;
